/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:18:41
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/readMore.js
 */
export default {
    // readMore
    readMore: {
        showHeight: 400,
        toggle: false,
        closeText: '展开阅读全文',
        openText: '收起',
        color: '#2979ff',
        fontSize: 14,
        textIndent: '2em',
        name: ''
    }
}
